import { createFileRoute } from '@tanstack/react-router';
import { SalaryPaymentReportProfileRegistryPage } from './-components/SalaryPaymentReportProfileRegistryPage';
export const Route = createFileRoute('/_staff/salary-and-wages-mock/_layout/settings/salary-payment-reports/')({
  component: SalaryPaymentReportProfileRegistryPage
});